 <template>
  <b-form inline>
    <b-form-select class="mb-1 mr-sm-1 mb-sm-0" size="sm" v-model="transition"
    :options="options_select">
    </b-form-select>
  </b-form>
</template>

<script>

export default {
  props: {
    ticket: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      transition: null,
      options_select: []
    }
  },
  methods: {
    updatePropersEstatsSelect () {
      this.options_select = [{
        value: null,
        text: this.ticket.estat.displayname,
        disabled: true,
        selected: true
      }].concat(
        this.ticket.propers_estats.filter(transition => 'cancel' !== transition.trigger).map(transition => {
          return {
            value: transition['trigger'],
            text: transition['displayname']
          }
        })
      )
    }
  },
  created () {
    this.updatePropersEstatsSelect()
  },
  watch: {
    transition: function (newVal) {
      this.$emit('changeState', {
        transition: newVal
      })
    },
    ticket: function () {
      this.transition = null
      this.updatePropersEstatsSelect()
    }
  }
}
</script>

<style scoped>
</style>
